/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationEmailPreferencesControllerGetNotificationEmailPreferences } from "./notificationEmailPreferencesControllerGetNotificationEmailPreferences";
import { notificationEmailPreferencesControllerResetNotificationEmailPreferences } from "./notificationEmailPreferencesControllerResetNotificationEmailPreferences";
import { notificationEmailPreferencesControllerUpdateNotificationEmailPreferences } from "./notificationEmailPreferencesControllerUpdateNotificationEmailPreferences";

export function notificationEmailPreferencesService() {
  return { notificationEmailPreferencesControllerGetNotificationEmailPreferences, notificationEmailPreferencesControllerUpdateNotificationEmailPreferences, notificationEmailPreferencesControllerResetNotificationEmailPreferences }
}